import api from "@/utils/axiosInterceptor";
import { AxiosResponse } from "axios";

export interface AiMetric {
  label: string;
  tp: number;
  fp: number;
  tn: number;
  fn: number;
  sensitivity: number;
  specificity: number;
  accuracy: number;
}

export interface AiEvalResponse {
  labels: Record<string, number>;
  r: Array<{
    id: number;
    study_id: number;
    label: string;
    ai_value: number;
    rad_value: number;
    createdAt: string;
  }>;
  summary?: AiSummary;
}

export interface AiSummary {
  total_studies: number;
  labels_extracted: number;
  total_findings: number;
}

export interface Evaluator {
  id: number;
  username: string;
  name?: string;
}

export interface Radiologist {
  id: string | number;
  name: string;
  hospital: string;
  studies: number;
  sensitivity: number;
  specificity: number;
  accuracy?: number;
}

export interface Hospital {
  id: string | number;
  name: string;
  location: string;
  radiologists: number;
  totalStudies: number;
  avgSensitivity: number;
  avgSpecificity: number;
}

export const AdminAPI = {

  getSummary: (username?: string): Promise<AiSummary> =>
    api.get("/ai-evaluation/summary", { params: username ? { username } : {} }).then((res: AxiosResponse) => res.data),

  getMetrics: (label?: string, username?: string): Promise<AiMetric[]> =>
    api.get("/ai-evaluation/metrics", {
      params: {
        ...(label ? { label } : {}),
        ...(username ? { username } : {}),
      },
    }).then((res: AxiosResponse) => res.data),

  runEvaluation: (studyId: number | string): Promise<AiEvalResponse> =>
    api.get(`/ai-evaluation/${studyId}`).then((res: AxiosResponse) => res.data),

  getStudyMetrics: (studyId: number | string, username?: string): Promise<AiMetric[]> =>
    api.get(`/ai-evaluation/metrics/${studyId}`, {
      params: username ? { username } : {},
    }).then((res: AxiosResponse) => res.data),

  getEvaluators: (): Promise<Evaluator[]> =>
    api.get("/ai-evaluation/evaluators").then((res: AxiosResponse) => res.data),

  getRadiologists: (): Promise<Radiologist[]> =>
    api.get("/admin/radiologists").then((res: AxiosResponse) => res.data),

  getRadiologist: (id: string | number): Promise<Radiologist> =>
    api.get(`/admin/radiologists/${id}`).then((res: AxiosResponse) => res.data),

  getHospitals: (): Promise<Hospital[]> =>
    api.get("/admin/hospitals").then((res: AxiosResponse) => res.data),

  getHospital: (id: string | number): Promise<Hospital> =>
    api.get(`/admin/hospitals/${id}`).then((res: AxiosResponse) => res.data),

  getStudyCount: (): Promise<any> =>
    api.get("/admin/studies/count").then((res: AxiosResponse) => res.data),
};